import * as Sentry from '@sentry/vue'

export default {
  install(app, { router }) {
    // same as before: skip in local serve (NODE_ENV === 'development')
    if (import.meta.env.DEV) {
      return
    }

    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.MODE,
      integrations: [Sentry.browserTracingIntegration({ router })],
    })
  },
}
